import './normandy/style';
import FormStructure from './normandy/form_structure';

export default FormStructure;